const $topButton = document.querySelector('.n-footer__menu-button-top')

if ($topButton) {
    $topButton.addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    })
}
